import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {ServiceSocialGroup} from './service-social-group.model';
import {ServiceTargetGroupEnum} from "../../../../interfaces/global.interface";

export const loadServiceSocialGroups = createAction(
  '[ServiceSocialGroup/API] Load ServiceSocialGroups',
  props<{ serviceSocialGroups: ServiceSocialGroup[] }>()
);

export const addServiceSocialGroup = createAction(
  '[ServiceSocialGroup/API] Add ServiceSocialGroup',
  props<{ serviceSocialGroup: ServiceSocialGroup }>()
);

export const upsertServiceSocialGroup = createAction(
  '[ServiceSocialGroup/API] Upsert ServiceSocialGroup',
  props<{ serviceSocialGroup: ServiceSocialGroup }>()
);

export const addServiceSocialGroups = createAction(
  '[ServiceSocialGroup/API] Add ServiceSocialGroups',
  props<{ serviceSocialGroups: ServiceSocialGroup[] }>()
);

export const upsertServiceSocialGroups = createAction(
  '[ServiceSocialGroup/API] Upsert ServiceSocialGroups',
  props<{ serviceSocialGroups: ServiceSocialGroup[] }>()
);

export const updateServiceSocialGroup = createAction(
  '[ServiceSocialGroup/API] Update ServiceSocialGroup',
  props<{ serviceSocialGroup: Update<ServiceSocialGroup> }>()
);

export const updateServiceSocialGroups = createAction(
  '[ServiceSocialGroup/API] Update ServiceSocialGroups',
  props<{ serviceSocialGroups: Update<ServiceSocialGroup>[] }>()
);

export const deleteServiceSocialGroup = createAction(
  '[ServiceSocialGroup/API] Delete ServiceSocialGroup',
  props<{ id: string }>()
);

export const deleteServiceSocialGroups = createAction(
  '[ServiceSocialGroup/API] Delete ServiceSocialGroups',
  props<{ ids: string[] }>()
);

export const clearServiceSocialGroups = createAction(
  '[ServiceSocialGroup/API] Clear ServiceSocialGroups'
);

// CUSTOM ACTIONS
export const createServiceSocialGroups = createAction(
  '[ServiceSocialGroup/API] Create Service Social Groups',
  props<{ input: { serviceUniqueId: string, groupNames: ServiceTargetGroupEnum[] } }>()
);

export const getServiceSocialGroups = createAction(
  '[ServiceSocialGroup/API] Get all Service Social Groups',
  props<{ serviceUniqueId: string }>()
);
